var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplenishmentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H11C9.9 10 9 10.9 9 12V24C9 25.1 9.9 26 11 26H18L16 29V30H24V29L22 26H29C30.1 26 31 25.1 31 24V12C31 10.9 30.1 10 29 10ZM29 22H11V12H29V22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9538 20.3V14H24.1688V20.3H22.9538Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 20.3L18.3039 14H19.6809L21.9759 20.3H20.6889L18.9879 15.386L17.2779 20.3H15.9999ZM17.0169 18.869L17.3409 17.924H20.5449L20.8599 18.869H17.0169Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplenishmentIcon);
export default __webpack_public_path__ + "static/media/replenishment-icon.1799a46ec577e87a3dbc0b5b73ce865d.svg";
export { ForwardRef as ReactComponent };